export type DeliverabilityScore = 'great' | 'good' | 'ok' | 'bad';

export interface DeliverabilityPlacements {
  PRIMARY: number;
  PROMOTIONS: number;
  UPDATES: number;
  SOCIAL: number;
  SPAM: number;
  OTHER: number;
}

export interface DeliverabilityScoreResult {
  score: DeliverabilityScore;
  primaryRate: number;
  spamRate: number;
  otherInboxRate: number;
}

/**
 * Calculate deliverability score based on placement data
 */
export function calculateDeliverabilityScore(
  placements: DeliverabilityPlacements,
  totalTests: number,
): DeliverabilityScoreResult {
  const primaryRate = (placements.PRIMARY / totalTests) * 100;
  const spamRate = (placements.SPAM / totalTests) * 100;
  const otherInboxRate =
    ((placements.PROMOTIONS +
      placements.UPDATES +
      placements.SOCIAL +
      placements.OTHER) /
      totalTests) *
    100;

  let score: DeliverabilityScore;
  if (primaryRate > 80) {
    score = 'great';
  } else if (primaryRate > 60) {
    score = 'good';
  } else if (spamRate > 25) {
    score = 'bad';
  } else {
    score = 'ok';
  }

  return { score, primaryRate, spamRate, otherInboxRate };
}

/**
 * Check if a deliverability score indicates potential issues
 */
export function hasDeliverabilityIssues(score: DeliverabilityScore): boolean {
  return score === 'ok' || score === 'bad';
}
